import React, { FC } from "react";
import { SvgIconProps } from "@mui/material";
import OpacityIcon from "@mui/icons-material/Opacity";

export const FloodIcon: FC<SvgIconProps> = (props) => {
  return <OpacityIcon sx={{ fontSize: 14 }} {...props} />;
};
